<template>
  <div class="modal fade" :id="id" tabindex="-1" role="dialog"  aria-hidden="true">
    <div v-if="show !== false" class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="color-line"></div>
        <div class="modal-header">
          <h4 class="modal-title">Upload file on KMS</h4>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-xs-12">
              <div class="form-group" :class="{'has-error': titleError !== false}">
                <label class="control-label required" for="title">Page name</label>
                <input v-model="title" type="text" name="title" id="title" class="form-control">
                <span>This field corresponds to the title of the page on KMS</span>
                <span class="help-block" v-if="titleError !== false">{{titleError}}</span>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-xs-8">
              <div class="form-group" :class="{'has-error': spaceError !== false}">
                <label class="control-label required" for="spaces">Space</label>
                <v-select2 id="spaces" :options="spaces" :dropdownParent="id" :placeholder="'select a space'"
                           v-model="spaceSelected" :searchable="true" label="name">
                </v-select2>
                <span class="help-block" v-if="spaceError !== false">{{spaceError}}</span>
              </div>
            </div>
          </div>

          <div class="row" v-if="subSpaces.length">
            <div class="col-xs-8">
              <div class="form-group" :class="{'has-error': subSpaceError !== false}">
                <label class="control-label" for="subSpaces">Sub Space / parent page</label>
                <v-select2 id="subSpaces" :options="subSpaces" :dropdownParent="id" :placeholder="'select a sub space or parent page'"
                           v-model="subSpaceSelected" :searchable="true" label="title">
                </v-select2>
                <span class="help-block" v-if="subSpaceError !== false">{{subSpaceError}}</span>
              </div>
            </div>
          </div>
        </div>

        <div class="modal-footer">
          <button type="button" class="btn btn-default" data-dismiss="modal">Cancel</button>
          <vue-ladda type="submit" :loading="submit.loading" class="btn btn-info" :data-style="submit.dataStyle" v-on:click="save">Confirm</vue-ladda>
        </div>

      </div>
    </div>
  </div>
</template>

<script>

import VueLadda from 'vue-ladda'
import VSelect2 from '../utils/select2'

export default {
  name: 'UploadFileBic',
  components: {
    VSelect2,
    VueLadda
  },
  data () {
    return {
      id: null,
      show: false,
      title: '',
      titleError: false,
      fileExportId: null,
      spaces: [],
      spaceSelected: null,
      subSpaces: [],
      subSpaceSelected: null,
      spaceError: false,
      subSpaceError: false,
      submit: {
        loading: false,
        'dataStyle': 'zoom-in'
      }
    }
  },
  watch: {
    spaceSelected: function (val) {
      if (val !== null) {
        this.axios.get('bicworld/spaces/' + this.spaceSelected.key).then((response) => {
          this.subSpaces = response.data
        })
      }
    }
  },
  methods: {
    save: function () {
      this.titleError = false
      this.spaceError = false

      if (this.title.length === 0) {
        this.titleError = 'Title can\'t be empty'
      }

      if (this.spaceSelected === null) {
        this.spaceError = 'You must select a space'
      }

      if (this.titleError === false && this.spaceError === false) {
        let data = {
          title: this.title,
          space: this.spaceSelected.key,
          fileExportId: this.fileExportId
        }

        if (this.subSpaceSelected !== null) {
          data.subSpace = this.subSpaceSelected.pageId
        }

        $('#' + this.id).modal('hide')
        this.$emit('dataBicForUpload', data)
      }
    },
    openModal: function () {
      this.show = true

      setTimeout(() => {
        $('#' + this.id).modal('show')
      }, 200)

      $('#' + this.id).on('hide.bs.modal', () => {
        this.show = false
        this.spaceSelected = null
        this.subSpaceSelected = null
      })
    },
    setTitle: function (title) {
      this.title = title
    },
    setFileExportId: function (fileExportId) {
      this.fileExportId = fileExportId
    }
  },
  beforeMount () {
    this.id = '_' + Math.random().toString(36).substr(2, 9)
    this.axios.get('bicworld/spaces').then((response) => {
      this.spaces = response.data
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/modal/UploadFileBic.vue